import { Center } from '#core/components';

import styles from './ProfileButton.module.css';

export const ProfileButton = () => {
  return (
    <Center className={styles.button}>
      <span>N</span>
    </Center>
  );
};
